import { Menu } from '@headlessui/react';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Avatar } from 'antd';
import { RootState } from 'app/store';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FaUserTie } from 'react-icons/fa';
import { CONFIG_WEBSITE } from 'global/Global';
import AuthServiceApi from 'apis/api/Auth';
import Cookies from 'js-cookie';
import LogoutConfirm from './Logout/Logout';
import { BiLogOut } from 'react-icons/bi';
import Helpers from 'helpers/Helpers';
import { updateDeviceTokenMessage } from '@slice/user.slice';
import { ThunkDispatch } from '@reduxjs/toolkit';

const StyledMenu: any = styled(Menu)`
  &.ant-menu-horizontal:not(.ant-menu-light .ant-menu-dark) {
    > .ant-menu-submenu:hover,
    > .ant-menu-submenu-selected {
      color: inherit !important;
    }

    > .ant-menu-submenu:hover:after,
    > .ant-menu-submenu-selected:after {
      border-bottom: none !important;
    }
  }
  .app-header__user-menu .ant-menu-vertical.ant-menu-sub {
    max-width: 100px;
  }
  .ant-menu-submenu-arrow {
    display: none;
  }
`;

const User = styled.div`
  display: flex;
  align-items: center;
  .icon-caret-down {
    display: none;
    position: relative;
    top: 1px;
    margin-left: 8px !important;
    margin-right: 10px !important;
    font-size: 14px !important;
  }
`;

export default function UserMenuDropdown() {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const account = useSelector((state: RootState) => state.user.account);
  const tableSetting = useSelector((state: RootState) => state.user.tableSetting);
  const deviceTokenMessage = useSelector((state: RootState) => state.user.deviceTokenMessage);
  const selectedTheme = useSelector((state: RootState) => state.select.themeSelected);
  const [logoutVisible, setLogoutVisible] = useState(false);

  const handleClickLogout = () => {
    setLogoutVisible(true);
  };
  const handleLogOut = async () => {
    const iTableSetting = Object.assign({ username: account?.username }, tableSetting);
    localStorage.setItem(account?.username + '/TableSetting', JSON.stringify(iTableSetting));

    try {
      // gọi yc huỷ device token trước
      await AuthServiceApi.RemoveDeviceToken(deviceTokenMessage);
      await AuthServiceApi.Logout();
      console.log('deviceTokenMessage', deviceTokenMessage);
    } catch (error) {
      console.log('Lout', error);
    }
    Cookies.remove('token');
    localStorage.removeItem('role');
    setTimeout(() => {
      dispatch(updateDeviceTokenMessage(null));
      window.location.reload();
    }, 500);
  };

  const renderAvatar = useMemo(() => {
    return (
      <>
        {account.avatar ? (
          <Avatar src={`${process.env.REACT_APP_URL_AUTH + account.avatar}`} style={{ color: '#f56a00' }}>
            {Helpers.FormatNameAccountAvt(
              (account && account.displayName) || '',
              (account && account.username) || '',
              'userName'
            )}
          </Avatar>
        ) : (
          <Avatar style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}>
            {Helpers.FormatNameAccountAvt(
              (account && account.displayName) || '',
              (account && account.username) || '',
              'userName'
            )}
          </Avatar>
        )}
      </>
    );
  }, [account]);
  return (
    <>
      <LogoutConfirm callbackLogout={handleLogOut} visible={logoutVisible} setVisible={setLogoutVisible} />
      <Menu>
        <Menu.Button className="flex items-center">
          {renderAvatar}
          <div className="flex mx-2">
            {account ? (
              <WapperInfo theme={selectedTheme}>
                <div className="h-fit cursor-pointer">
                  <p style={{ fontSize: '13px' }} className="cursor-pointer font_family_wrapper leading-4 mb-0">
                    {account?.username}
                  </p>
                </div>
                <div className="h-fit cursor-pointer">
                  <p style={{ fontSize: '13px' }} className="cursor-pointer font_family_wrapper leading-4 mb-0">
                    {account && account.phone != null && account.phone != undefined
                      ? account.phone!.length > 11
                        ? account.phone!.slice(-11).replace(/^.{1,7}/, '*******')
                        : account?.phone!.replace(/^.{1,7}/, '*******')
                      : ''}
                  </p>
                </div>
              </WapperInfo>
            ) : (
              <>
                <div className="animate-pulse flex w-20">
                  <div className="flex-1 space-y-2">
                    <div className="h-2 bg-gray-300 rounded"></div>
                    <div className="space-y-1">
                      <div className="grid grid-cols-3 gap-1">
                        <div className="h-2 bg-gray-300 rounded col-span-2"></div>
                        <div className="h-2 bg-gray-300 rounded col-span-1"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </Menu.Button>
        <Menu.Items>
          <div
            className={classNames(
              'absolute transform origin-left top-[3rem] right-3 z-[100] w-fit text-base list-none bg-white rounded-md divide-y divide-gray-100 shadow-md dark:bg-gray-700'
            )}
          >
            <ul className="py-1" aria-labelledby="dropdownButton">
              <li>
                <Link
                  to={'/thong-tin-tai-khoan'}
                  className="no-underline block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                >
                  <div className="flex space-x-2">
                    <FaUserTie size={20} />
                    {t('Header.UserMenu.UserInfo')}
                  </div>
                </Link>
              </li>
              <li>
                <div className="no-underline block py-2 px-4 text-xs text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">
                  <div className="flex space-x-2">
                    {CONFIG_WEBSITE.versionDisplay} {CONFIG_WEBSITE.lastUpdate}
                  </div>
                </div>
              </li>
              {/* {CONFIG_WEBSITE.keyWeb == 'AD' && (
              <li>
                <Link
                  to={'/huong-dan-su-dung'}
                  className="no-underline block py-2 px-4 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                >
                  <div className="flex space-x-2">
                    <MdOutlineIntegrationInstructions size={20} />
                    {t('Header.Instruction.TitleShort')}
                  </div>
                </Link>
              </li>
            )} */}

              <li onClick={handleClickLogout}>
                <div className="cursor-pointer block py-2 px-4 text-sm text-left text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white">
                  <div className="flex space-x-2">
                    <BiLogOut size={20} />
                    <div>{t('Header.UserMenu.Logout')}</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </Menu.Items>
      </Menu>
    </>
  );
}

const WapperInfo = styled.div.attrs({
  className: 'flex-1'
})<{ theme?: any }>`
  color: ${({ theme }) => theme.colors!.text};
`;
